module.exports = __webpack_public_path__ + "assets/img/vkontakte.6466a221.webp";